module.exports = __webpack_public_path__ + "img/type1.0d5d3a55.png";